"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DslServiceCms = void 0;
var DslServiceCms = /** @class */ (function () {
    function DslServiceCms() {
        this.dslModelHeadingLabel = 'About your DSL service';
        this.dslDescriptionOneTxt = 'You currently have AT&T DSL Internet service installed at your home.';
        this.dslDescriptionTwoTxt = 'This is a reminder that we\'ll replace your DSL service with your new AT&T '
            + 'Internet at the time of installation, which will require new equipment. Any unused portion '
            + 'of your monthly AT&T DSL service charges will be credited to your DSL account.';
        this.dslDescriptionThreeTxt = 'And don\'t worry; you\'ll be able to keep your current email address.';
    }
    return DslServiceCms;
}());
exports.DslServiceCms = DslServiceCms;
//# sourceMappingURL=dslservice.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/dslservice.cms.js
// module id = 1981
// module chunks = 8